import ApiService from "@/services/ApiService";

class SecurityService {
  verifyIcOtp(req) {
    return ApiService.post(
      "/sec/v2/user-devices/verify-device-otp/verify-ic-otp",
      req
    );
  }

  verifyDeviceOtp(otp) {
    return ApiService.post(
      "/sec/v2/user-devices/verify-device-otp/verify-web-otp",
      {
        otp
      }
    );
  }
}

export default new SecurityService();
